import Cards from "./TestimonialCards.jsx";
import client from "../assets/guy.png";
import fmiano from "../assets/fmiano.png";
const Testimonials = () => {
  return (
    <div className="py-10">
      <div>
        <h1 className="text-4xl md:text-5xl font-black pb-4">TESTIMONIALS</h1>
      </div>
      <div className="grid sm:grid-rows-2 md:grid-cols-2 md:grid-rows-1 gap-5">
        <Cards
          imgsrc={client}
          name="Dj Marty McFly"
          text="This team helped me book my events by creating videos for my business and personal brand. Check him out!"
        />
        <Cards
          imgsrc={fmiano}
          name="Franklin Miano"
          text="I really loved the way they communicate and executes their works, from thinking of a good hashtags to interpreting ideas. Kudos to this team, I can't thank them enough."
        />
      </div>
    </div>
  );
};

export default Testimonials;
